// @flow
import ErrorMessage from 'components/ErrorMessage';
import InputPattern from 'components/InputPattern';
import Stylo from 'components/Stylo';
import { styles as textInputStyles } from 'components/TextInput';
import ValidationError from 'components/ValidationError';
import View from 'components/View';
import { FastField } from 'formik';
import React from 'react';

type Props = {
  label?: string,
  onChange?: Event => void,
  onBlur?: Event => void,
  name?: string,
  defaultValue?: string,
  value?: string,
  disabled?: boolean,
  children: HTMLOptionElement[]
};

const styles = {
  label: {
    alignItems: 'flex-start'
  },
  inputPattern: ({ disabled }, { components: { Select } }) => ({
    ...Select,
    ...(disabled ? Select[':disabled'] : null),
    appearance: 'none',
    display: 'flex'
  })
};

const SelectBase = ({
  options,
  name,
  value,
  disabled,
  style,
  onChange,
  onFocus,
  onBlur,
  defaultValue,
  ...props
}) => (
  <Stylo
    as="select"
    weight="bold"
    style={[style, styles.inputPattern]}
    nativeProps={{ name, value, disabled, onChange, onBlur, onFocus, defaultValue }}
    disabled={disabled}
    {...props}>
    {options}
  </Stylo>
);

const Select = ({ children, isVertical = false, ...props }: Props) => (
  <View as="label" isExpanded style={styles.label}>
    <InputPattern
      {...props}
      Base={SelectBase}
      iconRight="arrow-down-3"
      options={children}
      style={textInputStyles.borderInput}
      styleBox={{ flexDirection: isVertical ? 'column' : 'row', alignItems: 'flex-start' }}
    />
  </View>
);

const inForm = SomeSelect => ({ name, ...props }) => (
  <FastField name={name}>
    {({ field, form: { isSubmitting } }) => (
      <>
        <SomeSelect
          {...field}
          {...props}
          disabled={props.disabled || isSubmitting}
          onChange={
            props.onChange
              ? e => {
                  field.onChange(e);
                  props.onChange(e);
                }
              : field.onChange
          }
        />
        <ErrorMessage name={name} component={ValidationError} />
      </>
    )}
  </FastField>
);

const SelectForm = inForm(Select);

export { SelectForm };

export default Select;
